import { Skeleton } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";

export default function ShareQrCode(props) {
  const { classes, isShareLinkLoading, shareUrl } = props;

  return (
    <div className={classes.shareLink} data-testid="share-qr-code-container">
      <div className={classes.qrCode}>
        {!isShareLinkLoading ? (
          <QRCodeSVG
            value={shareUrl}
            size={200}
            bgColor="#FFF"
            style={{
              border: "2px solid white",
              cursor: "pointer",
              marginBottom: 120,
            }}
          />
        ) : (
          <Skeleton
            sx={{ bgcolor: "grey.900", margin: "auto" }}
            variant="rectangular"
            width={200}
            height={200}
            animation="wave"
          />
        )}
      </div>
    </div>
  );
}
